import {
  //   avalanche,
  // avalancheFuji,
  bsc,
  bscTestnet,
  //   goerli,
  //   mainnet,
  // zkSync,
  // zkSyncTestnet,
} from "wagmi/chains";
import type { Chain } from "wagmi/chains";

export const httpMethods = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE",
};

export const cdn = {
  cdn: {
    path: "https://img.bit5.com/", //'https://ik.imagekit.io/bit5/',
    detail: "?tr=w-540",
    thumbnail: "?tr=w-262",
    w350x192: "?tr=w-350,h-192",
    w1920x1080: "?tr=w-1920,h-1080",
    w100: "?tr=w-1000",
    w560: "?tr=w-560",
    w200: "?tr=w-2000",
    version: "&ua=20221121",
  },
  cloudinary: {
    path: "https://res.cloudinary.com/demo/image/fetch/",
  },
};

const supportedChains: SupportedChainsType = {
  testnet: [
    {
      ...bscTestnet,
      scan_url: "https://testnet.bscscan.com",
      hexId: "0x61",
      lendingContract: "0x7CDEe851050EbD22Dd7dDb6dfc97c73C5c36238f", // testnet
    },
    // {
    //   ...goerli,
    //   scan_url: "https://goerli.etherscan.io",
    //   hexId: "0x05",
    // },
  ],
  mainnet: [
    {
      ...bsc,
      scan_url: "https://bscscan.com",
      hexId: "0x38",
      lendingContract: "0x7CDEe851050EbD22Dd7dDb6dfc97c73C5c36238f", // mainnet
    },
    // {
    //   ...mainnet,
    //   scan_url: "https://etherscan.io",
    //   hexId: "0x01",
    // },
    // {
    //   ...avalanche,
    //   scan_url: "https://snowtrace.io",
    //   hexId: "0xa86a",
    // },
  ],
};

export const helpers = {
  testnet: {
    explorer: "https://testnet.bscscan.com/",
    noImage: "/images/no_image.png",
    transparent: "/images/gray.png",
    wbnb: "0xEf347ABbAEf4a2306e6e4a35237E0f62232b9734", // testnet
    marketplace: "0x7Acae93d95D37E2b5619c5Fd11387E5c77f5fBCe", // testnet
    lending: "0x7CDEe851050EbD22Dd7dDb6dfc97c73C5c36238f",
    treasuryAddress: "0x5be83Dc0A918095fb7FD56dc01B6b25fE96fef1D",
    chainId: "0x61", // testnet
    marketplace_url: "https://test.bit5.com",
    supportedChains: supportedChains.testnet,
  },
  mainnet: {
    explorer: "https://bscscan.com",
    noImage: "/images/no_image.png",
    transparent: "/images/gray.png",
    wbnb: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", // mainnet
    marketplace: "0xE792F41aaCAE6988C4d3a6A8D0C813Cf82C67C04", // mainnet
    lending: "0x7CDEe851050EbD22Dd7dDb6dfc97c73C5c36238f",
    treasuryAddress: "0x8af22d749E25E19a0fa51866a661A369110403F6",
    chainId: "0x38", // mainnet
    marketplace_url: "https://bit5.com",
    supportedChains: supportedChains.mainnet,
    rpcUrls: {
      default: {
        http: [
          "https://bsc-dataseed1.binance.org/",
          "https://bsc-dataseed2.binance.org/",
        ],
      },
      public: {
        http: [
          "https://bsc-dataseed1.binance.org/",
          "https://bsc-dataseed2.binance.org/",
        ],
      },
    },
  },
};

export type HelpersType = {
  explorer: string;
  noImage: string;
  transparent: string;
  wbnb: string;
  marketplace: string;
  treasuryAddress: string;
  chainId: string;
  marketplace_url: string;
  supportedChains: ChainType[];
};

type SupportedChainsType = {
  testnet: ChainType[];
  mainnet: ChainType[];
};

type ChainType = Chain & {
  scan_url: string;
  hexId: string;
  lendingContract?: string;
};

export type GetNetworkResultType = {
  chain: ChainType & { unsupported: boolean };
  chains: ChainType[];
};
